import { Box, Checkbox, Flex } from "@mantine/core";

import { TextWrapper } from "@/components/TextWrapper";

interface PhysicalExamSectionProps {
  title: string;
  children: React.ReactNode;
  onDecline?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  isDeclined?: boolean;
}

export default function PhysicalExamSection({
  title,
  children,
  onDecline,
  isDeclined,
}: PhysicalExamSectionProps) {
  return (
    <Box mt="xl" aria-label={`${title} section`}>
      <Flex
        pb="sm"
        justify="space-between"
        style={{ borderBottom: "1px solid var(--mantine-color-cream-3)" }}
      >
        <TextWrapper c="gray.6" variant="bold">
          {title}
        </TextWrapper>
        {onDecline && <Checkbox label="Decline exam" onChange={onDecline} checked={isDeclined} />}
      </Flex>
      {children}
    </Box>
  );
}
